import { currentSBVersion } from "@/services/storyBlokVersionUpdate";
import { replaceAllSbDomainsWithAkasa } from "@/utils/akasaDomainConverters/replaceSbDomainWithAkasa";
import Storyblok from "../utils/storyblok";

const sbParams = {
  version: "published",
  language: "en", 
  cv: currentSBVersion(),
  from_release: ""
};

async function getAllPagesData(){
    const response = Storyblok.get("cdn/stories/mob/all-pages", sbParams);
    return response;
}

export async function fetchSpecialfaresRestrictions() {
  try {
    
    if (sessionStorage) {
      const storedData = sessionStorage.getItem("specialPassengers");
      if (storedData) {
        return JSON.parse(storedData);
      }
    }

    const sbParams = {
      version: "published",
      resolve_relations: ["featured-posts.posts", "selected-posts.posts"],
      language: "en", 
      cv: currentSBVersion(),
      from_release: ""
    };

    const { data } = await Storyblok.get("cdn/stories/mob/all-pages", sbParams);

    const specialPassengers = data?.story?.content?.specialPassengers;

    if (sessionStorage) {
      sessionStorage.setItem("specialPassengers", JSON.stringify(specialPassengers));
    }

    
    return specialPassengers;
  } catch (error) {
    console.error("Error fetching special fares restrictions:", error);
  }
}

export async function fetchSpecialfaresContent() {
  try {
    if ( sessionStorage ) {
      const storedData = sessionStorage.getItem("specialFaresContent");
      if (storedData) {
        return JSON.parse(storedData);
      }
    }

    const response = await getAllPagesData();

    let bookingData = response?.data?.story?.content?.booking;

    bookingData = replaceAllSbDomainsWithAkasa({ dataToUpdate: bookingData });

    if ( sessionStorage) {
      sessionStorage.setItem("specialFaresContent", JSON.stringify(bookingData));
    }
    return bookingData;
  } catch (error) {
    console.error("Error fetching special fares content:", error);
    return null;
  }
}

export async function fetchSsrContent() {
  try {
    const response = await getAllPagesData();
    const dataWithUpdatedDomain = replaceAllSbDomainsWithAkasa({ dataToUpdate: response });
    return dataWithUpdatedDomain;
  } catch (err) {
    console.error("Error Fetching Ssr Content : ", err);
  }
}

export async function fetchBundlesContent() {
  try {
    const response = await getAllPagesData();
    const dataWithUpdatedDomain = replaceAllSbDomainsWithAkasa({ dataToUpdate: response });
    return dataWithUpdatedDomain;
  } catch (Err) {
    console.error("Error fetching Bundles Content: ", Err);
  }
}

export async function fetchproductClassContent(options: {}) {
  try {
    const { signal } = options;
    const response = await Storyblok.get("cdn/stories/mob/all-pages", { ...sbParams, signal });
    const dataWithUpdatedDomain = replaceAllSbDomainsWithAkasa({ dataToUpdate: response });
    return dataWithUpdatedDomain;
  } catch (err) {}
}

export async function fetchdangerousgoodsContent() {
  try {
    if (sessionStorage) {
      // Attempt to retrieve stored data from sessionStorage
      const storedData = sessionStorage.getItem("dangerousGoodsContent");

      // If data is found in sessionStorage, return it
      if (storedData) {
        return JSON.parse(storedData);
      }
    }
    const { data } = await getAllPagesData();

    const dangerousGoodsContent = data?.story?.content?.check_in || {};

    // If sessionStorage is available, store the data in sessionStorage
    if (sessionStorage) {
      sessionStorage.setItem("dangerousGoodsContent", JSON.stringify(dangerousGoodsContent));
    }

    return dangerousGoodsContent;
  } catch (error) {
    console.error("Error fetching dangerous goods content:", error);
  }
}


export async function fetchContatUsToEmailId() {
  try {
    const response = await getAllPagesData();
    if (response) return response;
    return "";
  } catch (err) {
    console.error("Error in fetching contact email : ", err);
  }
}

export async function fetchAircraftImageByTailNumber() {
  try {
    const response = await getAllPagesData();
    if (response?.data?.story?.content?.flightStatus) {
      return response;
    } else {
      return { message: "No flight status data available" };
    }
  } catch (err) {
    console.error("Error in fetching aircraft image: ", err);
    return null;
  }
}

export async function fetchCancellationPolicyContent() {
  try {
    const response = await getAllPagesData();
    const dataWithUpdatedDomain = replaceAllSbDomainsWithAkasa({ dataToUpdate: response });
    return dataWithUpdatedDomain;
  } catch (error) {
    console.error("Error Fetching cancellation policy : ", error);
  }
}

export async function fetchSeatSelectionContent() {
  try {
    const response = await getAllPagesData();
    const dataWithUpdatedDomain = replaceAllSbDomainsWithAkasa({ dataToUpdate: response });
    return dataWithUpdatedDomain;
  } catch (err) {
    console.error("Error fetching seating selction content: ", err);
  }
}

export async function getPopularCities() {
  try {
    const response = await getAllPagesData();
    return response;
  } catch (err) {
    console.error("Error fetching Popular Cities data : ", err);
  }
}

export async function fetchCMSConfig() {
  try {
    const response = await getAllPagesData();
    return response;
  } catch (Err) {
    console.error("Error fetching CMS Config data: ", Err);
  }
}

export async function fetchCMSMasterData() {
  try {
    const response = await getAllPagesData();
    return response;
  } catch (e) {
    return null;
  }
}

export async function fetchNavitairConfigForSeats() {
  try {
    const response = await getAllPagesData();
    return response;
  } catch (err) {
    console.error("Error Fetching NavitairConfigSeats : ");
  }
}

export async function fetchWebSwitchs() {
  try {
    const response = await getAllPagesData();
    return response;
  } catch (err) {
    console.error("Error fetching web switches: ", err);
  }
}

export async function fetchMealCategories() {
  try {
    const response = await getAllPagesData();
    return response;
  } catch (err) {
    console.error("Error Fetching Meal Categories : ", err);
  }
}

export async function getTestEnvEntryPassword() {
  try {
    const response = await getAllPagesData();
    return response;
  } catch (err) {
    console.error("Error fetching Test Entry password : ", err);
  }
}

export async function fetchHealthDeclarationConditions() {
  try {
    const response = await getAllPagesData();
    const dataWithUpdatedDomain = replaceAllSbDomainsWithAkasa({ dataToUpdate: response });
    return dataWithUpdatedDomain;
  } catch (err) {
    console.error("Error Fetching Health Categories");
  }
}

export async function fetchUndoCheckInBeforeTime() {
  try {
    const response = await getAllPagesData();
    return response;
  } catch (err) {console.error("Error fetching the Undo Check-in Before time :",err)}
}

export async function fetchNumrSurveyTokens() {
  try {
    const response = await getAllPagesData();
    return response;
  } catch (error) {
    console.warn("Error fetching nums token", error);
    return {};
  }
}

export async function fetchDigiYatraLogo() {
  try {
    const { data } = await getAllPagesData();
    if (data) {
      const dataWithUpdatedDomain = replaceAllSbDomainsWithAkasa({
        dataToUpdate: data?.story?.content?.brokerImageReferences[0]?.image?.filename
      });
      return dataWithUpdatedDomain;
    }
    return "";
  } catch (error) {
    console.warn("Error in Fetching digiYatraLogo", error);
    return {};
  }
}

export async function fetchInternationalBaggageRestriction() {
  try {
    const { data } = await getAllPagesData();
    if (data) {
      return data?.story?.content?.internationalBaggageRestrictions;
    }
    return "";
  } catch (err) {
    console.error("Error Fetching :", err);
  }
}

export async function fetchInternationalVisaRequirements() {
  try {
    const { data } = await getAllPagesData();
    if (data) {
      const responsedata = data?.story?.content?.internationalVisaRequirements || [];
      return responsedata;
    }
    return "";
  } catch (error) {
    console.warn(error);
    return {};
  }
}

export async function fetchPromoCodeLength() {
  try {
    const { data } = await getAllPagesData();
    if (data) {
      const responsedata = data?.story?.content?.promoCodeMaxLength || [];
      return responsedata;
    }
    return "";
  } catch (error) {
    console.warn(error);
    return {};
  }
}

  export async function fetchSecurityWeekData() {
  try {
    const { data } = await getAllPagesData();
    if (data) {
      const responsedata = data?.story?.content || [];
      const enableSecurityWeek = responsedata?.enableSecurityWeek;
      const securityWeekImage = responsedata?.securityWeekImage;
      return {enableSecurityWeek, securityWeekImage}
    }
    return "";
  } catch (error) {
    console.warn("Error in Fetching ASCW Sticker",error);
    return {};
  }
}

export async function fetchStationAliases() {
  try {
    const { data } = await getAllPagesData();
    if (data) {
      const responsedata = data?.story?.content?.stationAliases || [];
      return responsedata;
    }
    return "";
  } catch (error) {
    console.warn(error);
    return {};
  }
}

export async function fetchAirlineChange() {
  try {
    const { data } = await getAllPagesData();
    if (data) {
      const responsedata = data?.story?.content?.codeShare || [];
      return responsedata;
    }
    return "";
  } catch (error) {
    console.warn(error);
    return {};
  }
}